<div class="relative isolate p-4 rounded-lg min-h-full">
    <!-- Glass backdrop (sibling, not parent of fixed elements) -->
    <div class="absolute inset-0 bg-white dark:bg-surface-0 backdrop-blur-sm rounded-lg -z-10 border border-purple-500/10 dark:border-purple-500/20"></div>

    <div class="space-y-3">
        <div class="mb-3">
            <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
                <div class="flex-1">
                    <h1 class="text-xl sm:text-2xl font-medium text-[#141437] dark:text-white">
                        Arrangement's Analytics</h1>
                    <p class="text-slate-600 dark:text-slate-400 text-xs sm:text-sm mt-1">Comprehensive
                        {{ selectedButtonTooltip() || 'arrangement cron analytics and admin performance tracking' }}</p>
            </div>
        </div>
        </div>
    
    <div class="mb-4 mt-3">
        <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4">
            <div class="flex justify-start items-center gap-2 sm:gap-3 flex-wrap">
                @for (button of selectionButtons; track button.value) {
                <button type="button"
                    class="flex items-center justify-center min-w-[102px] px-2 py-1.5 rounded-lg transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-purple-500/50 focus:ring-offset-2 dark:focus:ring-offset-surface-1 gap-2 border cursor-pointer"
                    [ngClass]="{
                            'bg-purple-500 dark:bg-purple-600 text-white border-purple-500 dark:border-purple-600 shadow-md shadow-purple-500/20 dark:shadow-purple-600/30 hover:bg-purple-600 dark:hover:bg-purple-700 hover:shadow-lg hover:shadow-purple-500/30 dark:hover:shadow-black/40': selectedButton() === button.value,
                            'bg-white dark:bg-surface-1 text-slate-700 dark:text-slate-200 border-purple-500/20 dark:border-purple-500/30 hover:border-purple-500/50 dark:hover:border-line-strong hover:bg-purple-50/50 dark:hover:bg-white/5 hover:shadow-sm': selectedButton() !== button.value
                        }" (click)="selectTab(button.value)">
                    <span class="text-base font-medium whitespace-nowrap">{{ button.label }}</span>
                </button>
                }
            </div>
    
            <!-- Right-side controls — keeps the existing date picker
                 (only on tabs that need it) and adds the "Customize
                 layout" button so the user can reorder / hide the tab
                 strip itself. The button is hidden in mixedMode so the
                 component stays clean when embedded into My Dashboard. -->
            <div class="flex-shrink-0 flex items-center gap-2 sm:gap-3">
                @if (showDatePicker()) {
                <app-date-picker [showComparison]="false" [showGroupBy]="true" [value]="{
                            startDate: startDate(),
                            endDate: endDate(),
                            unit: unit(),
                            comparisonType: 'none'
                        }" [allowedGroupByUnits]="['day','week','month','quarter','year']"
                    (dateRangeChange)="onDateRangeChange($event)">
                </app-date-picker>
                }
                
                @if (!mixedMode()) {
                <button type="button" (click)="openCustomizeLayout()"
                    class="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium border border-[#AD46FF]/30 text-[#AD46FF] bg-white/95 dark:bg-slate-800/95 dark:border-purple-500/40 hover:bg-violet-50 dark:hover:bg-white/5 hover:border-[#AD46FF]/60 hover:shadow-md transition-all duration-200 cursor-pointer whitespace-nowrap"
                    [attr.aria-label]="'Customize layout'" title="Customize layout">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <rect width="7" height="9" x="3" y="3" rx="1" />
                        <rect width="7" height="5" x="14" y="3" rx="1" />
                        <rect width="7" height="9" x="14" y="12" rx="1" />
                        <rect width="7" height="5" x="3" y="16" rx="1" />
                    </svg>
                    <span>Customize layout</span>
                </button>
                }
                @if (isDenefits()) {
                <button (click)="openAiAssistant()"
                    class="gradient-border text-[#141437] dark:text-white text-sm lg:text-xs font-medium px-5 lg:px-3 py-2.5 lg:py-3 rounded-lg transition-all duration-200 shadow-[0px_6px_12px_-6px_#AD46FF] hover:shadow-[0px_7px_12px_-5px_#AD46FF] flex items-center gap-2 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed">
                    <app-icon-v2 name="sparkles" [size]="16" />
                    Ask Prism AI
                </button>
                }
            </div>
        </div>
    </div>
    
    <!-- Component Content Area -->
    <div class="mt-4">
        @if (selectedButton() === 1) {
        <app-overview-new
          [mixedMode]="mixedMode()"
          [visibleWidgetKeys]="visibleWidgetKeys()">
        </app-overview-new>
        } @else if (selectedButton() === 2) {
        <app-trends
          [mixedMode]="mixedMode()"
          [visibleWidgetKeys]="visibleWidgetKeys()">
        </app-trends>
        } @else if (selectedButton() === 3) {
        <app-admin-performance
          [mixedMode]="mixedMode()"
          [visibleWidgetKeys]="visibleWidgetKeys()">
        </app-admin-performance>
        }
    </div>
</div>
